export default __webpack_public_path__ + "static/media/sws-400.44de956f.jpg";